export default __webpack_public_path__ + "static/media/bronze.92bcae86.png";